<template>
    <ul class="flex flex-col gap-1">
        <li v-for="node in nodes" :key="node.id" class="w-full">
            <div class="flex items-center gap-1">
                <button type="button" @click="onSelect(node.slug)"
                    class="flex-auto text-left text-sm capitalize transition-all duration-300 hover:text-primary"
                    :class="activeSlug === node.slug ? 'font-semibold text-primary' : 'font-medium text-text'">
                    {{ node.name }} ({{ getNodeProductsCount(node) }})
                </button>

                <button
                    v-if="node.children && node.children.length"
                    type="button"
                    @click.stop="toggleNode(node.id)"
                    class="w-6 h-6 text-xs leading-6 text-center rounded-full text-text transition-all duration-300 hover:text-primary"
                    :aria-label="isNodeOpen(node.id) ? 'collapse' : 'expand'"
                >
                    <i :class="isNodeOpen(node.id) ? 'lab-line-chevron-up' : 'lab-line-chevron-down'"></i>
                </button>
            </div>

            <div v-if="node.children && node.children.length && isNodeOpen(node.id)" class="pl-3 mt-1 border-l border-slate-200">
                <CategoryTreeNavComponent :nodes="node.children" :activeSlug="activeSlug" @select="$emit('select', $event)" @toggle="$emit('toggle')" />
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'CategoryTreeNavComponent',
    props: {
        nodes: {
            type: Array,
            default: () => []
        },
        activeSlug: {
            type: String,
            default: ''
        }
    },
    emits: ['select', 'toggle'],
    data() {
        return {
            openNodeId: null,
        };
    },
    watch: {
        nodes: {
            handler() {
                this.syncOpenNode();
            },
            immediate: true,
        },
        activeSlug: {
            handler() {
                this.syncOpenNode();
            },
            immediate: true,
        },
    },
    methods: {
        onSelect(slug) {
            this.$emit('select', slug);
        },
        toggleNode(nodeId) {
            this.openNodeId = this.openNodeId === nodeId ? null : nodeId;
            this.$emit('toggle');
        },
        isNodeOpen(nodeId) {
            return this.openNodeId === nodeId;
        },
        containsSlug(node, slug) {
            if (!slug || !node) {
                return false;
            }

            if (node.slug === slug) {
                return true;
            }

            if (!Array.isArray(node.children) || node.children.length === 0) {
                return false;
            }

            return node.children.some((child) => this.containsSlug(child, slug));
        },
        getNodeProductsCount(node) {
            if (!node) {
                return 0;
            }

            const ownCount = Array.isArray(node.products)
                ? node.products.length
                : Number(node.products_count || 0);

            if (!Array.isArray(node.children) || node.children.length === 0) {
                return ownCount;
            }

            return ownCount + node.children.reduce((sum, child) => sum + this.getNodeProductsCount(child), 0);
        },
        syncOpenNode() {
            if (!this.activeSlug || !Array.isArray(this.nodes) || this.nodes.length === 0) {
                this.openNodeId = null;
                return;
            }

            const branchNode = this.nodes.find((node) => this.containsSlug(node, this.activeSlug));
            this.openNodeId = branchNode ? branchNode.id : null;
        }
    }
}
</script>
